export default "__VITE_ASSET__D7f2YOjs__"